"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderContainer = exports.ScrollArea = exports.FavoriteButtonSmall = exports.FavoriteButton = exports.ActionButton = exports.ActionButtonContainer = exports.LoadButton = exports.StyledBox = exports.StyledVideoPlayer = exports.StyledBackground = exports.StyledBrokenImage = exports.MediaCardWrapper = exports.MediaCardContent = exports.PlayButton = exports.StyledCardActionArea = exports.StyledName = exports.StyledCard = void 0;
var material_1 = require("@mui/material");
var Card_1 = __importDefault(require("../Card"));
var CardActionArea_1 = __importDefault(require("../CardActionArea"));
var colors_1 = require("../ThemeProvider/colors");
var Button_1 = __importDefault(require("../Button"));
var Box_1 = __importDefault(require("../Box"));
var VideoPlayer_1 = __importDefault(require("../VideoPlayer"));
exports.StyledCard = (0, material_1.styled)(Card_1.default, {
    name: 'StyledCard',
    shouldForwardProp: function (prop) { return !/skeleton/.test(String(prop)); },
})(function (_a) {
    var skeleton = _a.skeleton, isError = _a.isError;
    return ({
        position: 'relative',
        borderRadius: 3,
        minWidth: 100,
        maxWidth: 286,
        aspectRatio: '16/9',
        backgroundColor: colors_1.tannerGray['100'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            boxShadow: skeleton || isError
                ? ''
                : "0 8px 10px ".concat(colors_1.tannerBlack, "24, 0 3px 14px ").concat(colors_1.tannerBlack, "1F, 0 4px 14px ").concat(colors_1.tannerBlack, "33"), // 14% opacity, 12% opacity, 20% opacity
        },
        '&:focus': {
            outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
            outlineOffset: '3px',
        },
    });
});
exports.StyledName = (0, material_1.styled)(material_1.Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  color: white;\n  padding-left: 22px;\n  padding-bottom: 20px;\n  font-weight: 800;\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  color: white;\n  padding-left: 22px;\n  padding-bottom: 20px;\n  font-weight: 800;\n"])));
exports.StyledCardActionArea = (0, material_1.styled)(CardActionArea_1.default, {
    name: 'StyledCardActionArea',
})({
    height: '100%',
    width: '100%',
    '& img': {
        height: '100%',
    },
});
var MediaIconButton = (0, material_1.styled)(Button_1.default, { name: 'MediaIconButton' })({
    minWidth: 'unset',
    width: 40,
    height: 40,
    position: 'absolute',
});
exports.PlayButton = (0, material_1.styled)(MediaIconButton, { name: 'PlayButton' })({
    border: 'none',
    borderRadius: '50%',
    color: colors_1.tannerWhite,
    background: "".concat(colors_1.tannerBlack, "B3"),
    '&:hover, &:focus': {
        background: "".concat(colors_1.tannerBlack, "CC"),
        color: colors_1.tannerWhite,
    },
    '&:active': {
        background: "".concat(colors_1.tannerBlack, "E6"),
        color: colors_1.tannerWhite,
    },
    '&.Mui-focusVisible': {
        boxShadow: 'none',
        outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
        outlineOffset: '3px',
    },
    '& svg': {
        color: "".concat(colors_1.tannerWhite, "CC"),
        fontSize: '30px',
        width: 11.88,
        height: 16,
    },
});
exports.MediaCardContent = (0, material_1.styled)(material_1.CardContent, {
    name: 'MediaCardContent',
})({
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
});
exports.MediaCardWrapper = (0, material_1.styled)('div', {
    name: 'MediaCardWrapper',
})({
    '&:focus': {
        boxShadow: 'none',
        outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
        outlineOffset: '3px',
    },
});
exports.StyledBrokenImage = (0, material_1.styled)('div', { name: 'StyledBrokenImage' })({
    width: '20px',
    height: '20px',
});
exports.StyledBackground = (0, material_1.styled)(Box_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  height: 95px;\n  padding: 16px;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 8px;\n  flex-shrink: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0) 2%,\n    rgba(0, 0, 0, 0.15) 29%,\n    rgba(0, 0, 0, 0.9) 89.5%\n  );\n  position: absolute;\n  bottom: ", ";\n  left: ", ";\n  width: ", ";\n  overflow: hidden;\n"], ["\n  display: flex;\n  height: 95px;\n  padding: 16px;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 8px;\n  flex-shrink: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0) 2%,\n    rgba(0, 0, 0, 0.15) 29%,\n    rgba(0, 0, 0, 0.9) 89.5%\n  );\n  position: absolute;\n  bottom: ", ";\n  left: ", ";\n  width: ", ";\n  overflow: hidden;\n"])), function (props) { return (props.mediaType === 'img' ? '0' : '8px'); }, function (props) { return (props.mediaType === 'img' ? '0' : '7.5px'); }, function (props) {
    return props.mediaType === 'img' ? '100%' : 'calc(100% - 15px)';
});
exports.StyledVideoPlayer = (0, material_1.styled)(VideoPlayer_1.default, {
    name: 'StyledVideoPlayer',
})({
    width: '100%',
    height: 'auto',
    overflow: 'hidden',
});
exports.StyledBox = (0, material_1.styled)(Box_1.default, {
    name: 'StyledBox',
    shouldForwardProp: function (prop) { return !/size/.test(String(prop)); },
})(function (_a) {
    var _b;
    var size = _a.size, theme = _a.theme;
    return (_b = {
            padding: '6px',
            display: 'grid',
            justifyContent: 'start',
            gridGap: '12px'
        },
        _b[theme.breakpoints.down('md')] = {
            gridTemplateColumns: "repeat(".concat(size === 'sm' || size === 'auto' ? 2 : 4, ", 1fr)"), //the width of the card
        },
        _b[theme.breakpoints.up('md')] = {
            gridTemplateColumns: "repeat(".concat(size === 'md' || size === 'auto' ? 4 : 2, ", 1fr)"), //the width of the card
        },
        _b);
});
exports.LoadButton = (0, material_1.styled)(Button_1.default, {
    name: 'LoadButton',
})({
    width: '100%',
    height: 40,
    marginTop: 12,
});
exports.ActionButtonContainer = (0, material_1.styled)(Box_1.default, {
    name: 'ActionButtonContainer',
})(function (_a) {
    var _b = _a.isVideo, isVideo = _b === void 0 ? false : _b;
    return ({
        position: 'absolute',
        top: isVideo ? '16px' : '8px',
        right: isVideo ? '16px' : '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    });
});
exports.ActionButton = (0, material_1.styled)(MediaIconButton, { name: 'TrashButton' })({
    borderRadius: '3px',
    position: 'relative',
    padding: '8px',
    zIndex: 1,
    '& svg': {
        width: '17px',
        height: '17px',
    },
});
exports.FavoriteButton = (0, material_1.styled)(exports.ActionButton, {
    shouldForwardProp: function (propName) {
        return propName !== 'isFavorite';
    },
})(function (_a) {
    var isFavorite = _a.isFavorite;
    return ({
        color: isFavorite ? colors_1.tannerSemantic.error.color : undefined,
        '&:hover, &:focus, &:active': {
            color: isFavorite ? colors_1.tannerSemantic.error.color : undefined,
        },
    });
});
exports.FavoriteButtonSmall = (0, material_1.styled)(exports.FavoriteButton, {
    shouldForwardProp: function (propName) {
        return propName !== 'isFavorite';
    },
})(function (_a) {
    var isFavorite = _a.isFavorite, loading = _a.loading;
    return ({
        width: '32px',
        height: '32px',
        padding: '4px',
        // .prism-media-card is StyledCard
        '.prism-media-card:not(:hover):not(:focus-within) &': {
            display: isFavorite || loading ? undefined : 'none',
        },
    });
});
exports.ScrollArea = (0, material_1.styled)(Box_1.default)(function (_a) {
    var dataLength = _a.dataLength, loading = _a.loading;
    return ({
        paddingBottom: 2,
        aspectRatio: loading || (dataLength && dataLength >= 16) ? 15 / 8 : 'auto',
        overflow: 'auto',
        '&:focus-visible': {
            outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
            outlineOffset: '3px',
        },
    });
});
exports.LoaderContainer = (0, material_1.styled)('div', { name: 'LoaderContainer' })({
    width: '100%',
    gridColumn: 'span 4',
    textAlign: 'center',
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map